import { render, staticRenderFns } from "./PaginaAllestimenti.vue?vue&type=template&id=72d84621"
import script from "./PaginaAllestimenti.vue?vue&type=script&lang=js"
export * from "./PaginaAllestimenti.vue?vue&type=script&lang=js"
import style0 from "./PaginaAllestimenti.vue?vue&type=style&index=0&id=72d84621&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports